import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Animation } from '../../../theme/Animation.es.js';
import '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import 'react';
import { Icon } from '../../display/Icon/Icon.es.js';
import { Input } from '../Input/Input.es.js';
import { DateRangePickerValue } from './DateRangePickerValue.es.js';

const Styles = labelStyles("DateRangePickerInput", {
  root: (props) => css`
    cursor: ${props.isDisabled ? "default" : "pointer"};
  `,
  button: css`
    display: flex;
    align-items: center;
    min-width: 0;

    &[data-size=compact] {
      font: var(--zds-minimal-print-2);
    },
  `,
  clearSelectionButton: css`
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;

    &:hover,
    &:focus {
      color: var(--zds-text-default);
      transition: ${Animation.transitionValue};
    }
  `,
  placeholder: css`
    color: var(--zds-stroke-stronger);
    display: block;
    overflow: hidden;
    white-space: nowrap;
  `
});
const ClearSelectionButton = ({ clearSelection }) => {
  return jsx(
    "button",
    { type: "button", css: Styles.clearSelectionButton, onClick: clearSelection, title: "Clear Selection", "data-zds": true },
    jsx(Icon, { canAcceptPointerEvents: false, name: "formXCircle", size: 20 })
  );
};
const DateRangePickerInput = (props) => {
  const { value, clearSelection, size } = props;
  const { from, to } = value;
  const hasValue = Boolean(from || to);
  const showClearSelectionButton = hasValue && !props.isDisabled;
  return jsx(
    "div",
    { css: Styles.root(props), "data-zds": true },
    jsx(Input, { id: props.id, isDisabled: props.isDisabled, isErrored: props.isErrored, renderIconAfter: ({ isFocused, isHovered }) => showClearSelectionButton && jsx(ClearSelectionButton, { clearSelection, isFocused, isHovered }), renderIconBefore: ({ iconSize }) => jsx(Icon, { name: "actionCalendar", size: iconSize }), size }, (inputProps) => (
      // Intentionally `button` and not `Button` since it looks
      // and behaves differently.
      // eslint-disable-next-line jsx-a11y/role-supports-aria-props
      jsx("button", { "aria-controls": inputProps["aria-controls"], "aria-expanded": props.isOpen ? "true" : "false", "aria-haspopup": "true", "aria-invalid": inputProps["aria-invalid"], "aria-label": inputProps["aria-label"], "data-size": size, css: [inputProps.css, Styles.button], disabled: inputProps.disabled, id: inputProps.id, onClick: props.onClick, onKeyDown: inputProps.onKeyDown, type: "button", "data-zds": true }, hasValue ? jsx(DateRangePickerValue, { options: props.options, value: props.value }) : jsx("span", { css: Styles.placeholder, "data-zds": true }, props.placeholder))
    ))
  );
};

export { DateRangePickerInput };
//# sourceMappingURL=DateRangePickerInput.es.js.map
